import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import AudioGallery from '@fec/frontend-aron/modules/media/AudioGallery/AudioGallery';
import MediaLoading from '@fec/frontend-aron/elements/media/MediaLoading/MediaLoading';
import MediaError from '@fec/frontend-aron/elements/media/MediaError/MediaError';

const containers = document.querySelectorAll('.js-audio-gallery');

containers.forEach((container) => {
  const assets = JSON.parse(container.dataset.assets) ?? [];

  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <Suspense fallback={<MediaLoading type="audio-gallery" />}>
        <ErrorBoundary fallback={<MediaError />}>
          <AudioGallery assets={assets} />
        </ErrorBoundary>
      </Suspense>
    </React.StrictMode>,
  );
});
